/* import __COLOCATED_TEMPLATE__ from './source-item.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type { InspectItem } from './inspect-sections';

interface Signature {
  Args: {
    item: InspectItem;
  };
}

export default class SourceItemComponent extends Component<Signature> {
  @service declare intercomEventService: $TSFixMe;

  trackSourceClick = () => {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'source_item',
      section: 'inspect_sources',
      source_title: this.args.item.title,
    });
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::FinAnswer::Inspect::SourceItem': typeof SourceItemComponent;
    'ai-agent/playground/fin-answer/inspect/source-item': typeof SourceItemComponent;
  }
}
